const NAMESPACE = "element";

const KEYS = {
    moreHelpLinkText: "moreHelpLinkText"
};

const MESSAGES = {
    [KEYS.moreHelpLinkText]: {
        value: "More in new tab",
        comment: "Text for link to external help"
    }
};

export { KEYS, NAMESPACE, MESSAGES };
